export const UMB_MARK_ATTRIBUTE_NAME = 'data-mark';
